var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.893,
    cy: 15.026,
    fill: "#2153EB",
    rx: 14.893,
    ry: 14.763
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F2F2",
    d: "M23.792 16.213V22.3h-3.56V16.62c0-1.425-.514-2.4-1.803-2.4-.984 0-1.568.656-1.826 1.291-.094.227-.118.542-.118.86V22.3h-3.56s.048-9.617 0-10.612h3.56v1.504c-.007.011-.017.023-.023.034h.023v-.034c.473-.722 1.317-1.754 3.209-1.754 2.342 0 4.098 1.517 4.098 4.776zM9.2 6.571c-1.218 0-2.015.792-2.015 1.833 0 1.02.774 1.834 1.968 1.834h.023c1.242 0 2.014-.815 2.014-1.834-.024-1.04-.772-1.833-1.99-1.833zM7.398 22.3h3.559V11.687h-3.56V22.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8e42cac95e37291bd0e0a563c707224e.svg";
export { ForwardRef as ReactComponent };